import { render, staticRenderFns } from "./vendor-list.vue?vue&type=template&id=3ddaed93&scoped=true&"
import script from "./js/vendor-list.js?vue&type=script&lang=js&"
export * from "./js/vendor-list.js?vue&type=script&lang=js&"
import style0 from "./vendor-list.vue?vue&type=style&index=0&id=3ddaed93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddaed93",
  null
  
)

export default component.exports